(() => {
  const S = {
    box: '.order-nowItem',
    prices: '.productPrices.onetime-prices',
    cmp: '.comPrice .money',
    norm: '.normalPrice .money',
    bubble: '.bubble.redB',
    form: '.form, form[action^="/cart/add"]',
    variantInput: 'input[name="id"]',
    terms: '.shopify-payment-terms, shopify-payment-terms',
    subscribe: 'input[type="radio"][value="subscribe"]',
    onetime: 'input[type="radio"][value="one-time"]',
    customBtn: '.custom-add-to-cart',
    submitBtn: '.product-form__submit',
    pctEl: '.js-dpct'
  };

  const fmt = n => `$${(+n).toFixed(2)}`;
  const num = s => parseFloat((s||'').toString().replace(/[^\d.]/g,''))||0;

  function wire(box, idx){
    if (box._wired) return;

    const prices = box.querySelector(S.prices);
    const cmpEl = box.querySelector(S.cmp);
    const normEl = box.querySelector(S.norm);
    const bubble = box.querySelector(S.bubble);
    const form = box.querySelector(S.form);
    const variantInput = box.querySelector(S.variantInput);
    if (!prices || !cmpEl || !normEl || !bubble || !form || !variantInput) return;

    const d = prices.dataset;
    const subVariant = d.variantId;
    const sellingPlan = d.sellingId;
    const onePrice = +(d.onetimePrice || num(normEl.textContent));
    const subPrice = +(d.subsPrice || onePrice);
    const compareAt = +(d.onetimeCompare || num(cmpEl.textContent));

    const pctEl = box.querySelector(S.pctEl);
    if (pctEl) {
      const p = isFinite(compareAt)&&compareAt>0 ? Math.round((compareAt - subPrice)/compareAt*100) : 0;
      pctEl.textContent = Math.max(0, p);
    }

    if (!variantInput.dataset.orig) variantInput.dataset.orig = variantInput.value;

    const radios = box.querySelectorAll(`${S.subscribe},${S.onetime}`);
    radios.forEach(r => r.name = `opt-${idx}`);

    const subRadio = box.querySelector(S.subscribe);
    const oneRadio = box.querySelector(S.onetime);
    if (subRadio) subRadio.checked = true;
    if (oneRadio) oneRadio.checked = false;

    const btn = box.querySelector(S.customBtn) || box.querySelector(S.submitBtn);
    const labels = [...radios].map(r => r.closest('label')).filter(Boolean);
    const terms = box.querySelector(S.terms);

    const isSub = () => {
      const r = [...radios].find(r=>r.checked);
      return r ? r.value === 'subscribe' : true;
    };

    function updateUI(){
      const price = isSub() ? subPrice : onePrice;
      const save = Math.max(0, Math.round(compareAt - price));
      normEl.textContent = fmt(price);
      bubble.textContent = `SAVE $${save}!`;
      if (btn && btn.matches(S.customBtn)) {
        const t = btn.querySelector('.atc-text');
        if (t) t.textContent = isSub() ? 'SUBSCRIBE AND SAVE' : 'BUY NOW';
        else btn.textContent = isSub() ? 'SUBSCRIBE AND SAVE' : 'BUY NOW';
      }
      variantInput.value = isSub() ? subVariant : variantInput.dataset.orig;
      labels.forEach(l => {
        const checked = l.querySelector('input')?.checked;
        l.style.fontWeight = checked ? '700' : '';
        l.style.color = checked ? '#1773B0' : '';
        l.classList.toggle('active', checked);
      });
      if (terms) terms.style.display = isSub() ? 'none' : '';
    }

    radios.forEach(r=>r.addEventListener('change', updateUI));
    updateUI();

    async function handleAdd(e){
      if (btn && btn.matches(S.submitBtn)) e.preventDefault();
      const sub = isSub();
      const txt = btn ? btn.textContent : '';
      if (btn){ btn.disabled = true; btn.textContent = 'ADDING...'; }
      try{
        if (sub){
          document.querySelector('#upCart')?.classList.add('hide-cart');
          await fetch('/cart/clear.js',{method:'POST'});
          await fetch('/cart/add.js',{
            method:'POST',
            headers:{'Content-Type':'application/json'},
            body:JSON.stringify({ id: subVariant, quantity: 1, selling_plan: sellingPlan })
          });
          if (btn){ btn.disabled=false; btn.textContent=txt; }
          setTimeout(() => window.location.href = '/checkout', 250);
        }else{
          document.querySelector('#upCart')?.classList.add('hide-cart');
          await fetch('/cart/clear.js',{method:'POST'});
          await fetch('/cart/add.js',{
            method:'POST',
            headers:{'Content-Type':'application/json'},
            body:JSON.stringify({ id: variantInput.dataset.orig, quantity: 1 })
          });
          await fetch('/cart.js');
          if (btn){ btn.disabled=false; btn.textContent=txt; }
          setTimeout(() => window.location.href = '/checkout', 250);
        }
      }catch(err){
        console.error(err);
        if (btn){ btn.disabled=false; btn.textContent=txt; }
      }
    }

    if (btn) btn.addEventListener('click', handleAdd);
    box._wired = true;
  }

  const refresh = () => document.querySelectorAll(S.box).forEach((b,i)=>wire(b,i));
  refresh();
  new MutationObserver(refresh).observe(document.body,{childList:true,subtree:true});
})();